<script setup lang="ts">
import { locales } from 'macro-i18n';

import { locale as currentLocale, resolveLocalePath } from '@/context';

import LocaleSwitchBtn from './LocaleSwitchBtn.vue';
</script>

<template>
  <ul :class="$style.root">
    <li v-for="locale in locales" :key="locale">
      <LocaleSwitchBtn
        :href="resolveLocalePath($router.resolve($route).href, locale)"
        :title="$t`locales:${locale}`"
        :class="
          locale === currentLocale
            ? 'text-decoration-line-through disabled'
            : 'btn-underline'
        "
      >
        <span>{{ locale.slice(0, 2).toUpperCase() }}</span>
      </LocaleSwitchBtn>
    </li>
  </ul>
</template>

<style lang="scss" module>
.root {
  @include list-unstyled;

  margin-bottom: 0;
}
</style>
